export const GET_LOADING_DATA = "GET_LOADING_DATA";
